export default __webpack_public_path__ + "static/media/study-less-512x512.20a4e672.png";